import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 24a24 24 0 1 1 48 0 24 24 0 0 1-48 0Zm36.27-5.93A3.25 3.25 0 0 0 34 15.75c-2-.55-10-.55-10-.55s-8 0-10 .55c-1.1.3-1.97 1.2-2.27 2.32-.53 2.05-.53 6.33-.53 6.33s0 4.28.53 6.33A3.25 3.25 0 0 0 14 33.05c2 .55 10 .55 10 .55s8 0 10-.55c1.1-.3 1.97-1.2 2.27-2.32.53-2.05.53-6.33.53-6.33s0-4.28-.53-6.33Z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.6 28.8v-8l6.4 4-6.4 4Z",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }